<div class="wrapper">
  <div class="heading text-type-5">{{ data?.avgtemp }} &deg;F</div>
  <div class="sky-condition text-type-10">{{ data?.condition?.text }}</div>
  <div class="wind-speed text-type-10">{{ data?.wind }} MP/H</div>
</div>
